import { InternalThreadsActions } from '@store/reducers/threads/actions'
import * as ActionTypes from '@storeOld/actions'
import { CanvasActionTypes } from '@storeOld/reducers/canvas/canvas'
import { all, takeEvery, takeLatest } from 'redux-saga/effects'

import { CommentReadsActions, InternalCommentReadsActions } from '../actions'
import { list } from './list'
import { markOpenTargets } from './markOpenTargets'
import { markRead } from './markRead'
import { markUnread } from './markUnread'

export function* commentReadsSaga() {
  // Opening something, or new material arriving into something open. The
  // three `set` actions cover a deep link: the pin is selected before the
  // threads, comments and marks have loaded, so the mark is earned once they
  // are in. Built here rather than at module level: `canvas` sits in an import
  // cycle with the store, and its enum is not there yet when this file loads
  const openOrArrived = [
    CanvasActionTypes.SET_SELECTED_THREAD,
    ActionTypes.SHOW_COMMENTS,
    ActionTypes.OPEN_BLOCK,
    ActionTypes.OPEN_MODAL,
    ActionTypes.ADD_COMMENT,
    ActionTypes.SET_COMMENTS,
    InternalThreadsActions.add.type,
    InternalThreadsActions.set.type,
    InternalCommentReadsActions.set.type,
  ]

  yield all([
    // loaded with the project; on a project switch only the last answer counts
    takeLatest(CommentReadsActions.list, list),
    takeEvery(CommentReadsActions.markRead, markRead),
    takeEvery(CommentReadsActions.markUnread, markUnread),
    takeEvery(openOrArrived, markOpenTargets),
  ])
}
